(function () {
  /**
   * @module basicSearch
   */

  var basicSearch = {};

  /**
   * Init the basicSearch component by adding relevent event listeners
   *
   * @memberof module:basicSearch
   */

  basicSearch.init = function () {
    var searchForm = document.querySelector(
      '.qld__banner__search .qld__search-form',
    );
    var headerSearch = document.querySelector('#search-input-global-header');

    if (searchForm) {
      searchForm
        .querySelector('.qld__btn--search')
        .setAttribute('type', 'submit');
      searchForm
        .querySelectorAll('.qld__btn--search, .qld__text-input')
        .forEach((el) => {
          el.removeAttribute('disabled');
        });

      $('#search-input-global-basic-query').autocompletion({
        datasets: {
          organic: {
            collection: $('#search-input-global-basic-query').attr(
              'data-collection',
            ),
            program:
              'https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json',
            show: '5',
          },
        },
        typeahead: { hint: true },
        length: 3,
      });
    }

    if (headerSearch) {
      $('#search-input-global-header-query').autocompletion({
        datasets: {
          organic: {
            collection: $('#search-input-global-header-query').attr(
              'data-collection',
            ),
            program:
              'https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json',
            show: '5',
          },
        },
        typeahead: { hint: true },
        length: 3,
      });
    }

    if (document.querySelector('.qld__search__sort #search-sort')) {
      var selectElement = document.getElementById('search-sort');
      var currentUrl = new URL(window.location.href);
      var searchParams = new URLSearchParams(currentUrl.search);

      if (searchParams.has('sort')) {
        selectElement.value = searchParams.get('sort');
      }

      selectElement.addEventListener('change', function () {
        var selectedValue = this.value;
        searchParams.set('sort', selectedValue);
        currentUrl.search = searchParams.toString();
        window.location.href = currentUrl.toString();
      });
    }
  };

  var funnelbackAnalyticsSelector =
    '.funnelback-basic-search [data-funnelback-analytics], #search-best-bets [data-funnelback-analytics]';

  $(document).off('click.funnelbackAnalytics', funnelbackAnalyticsSelector);
  $(document).on(
    'click.funnelbackAnalytics',
    funnelbackAnalyticsSelector,
    function (event) {
      var analyticsUrl = $(event.currentTarget).attr(
        'data-funnelback-analytics',
      );
      if (!analyticsUrl) {
        return;
      }
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }
      event.preventDefault();
      var destination = event.currentTarget.getAttribute('href');
      var trackingUrl = analyticsUrl.trim();

      if (!trackingUrl) {
        if (destination) {
          window.location.assign(destination);
        }
        return;
      }

      try {
        window.location.assign(trackingUrl);
      } catch (e) {
        if (destination) {
          window.location.assign(destination);
        }
      }
    },
  );

  // Make basic search public
  QLD.basicSearch = basicSearch;

  window.addEventListener('DOMContentLoaded', function () {
    QLD.basicSearch.init();
  });
})();
